<template>
  <div class='landing'>    
    <div>      
      <img src="@/assets/images/ao-logo.svg" alt="">      
      <h1>
        <span>Booking Calendar</span>
      </h1>
       <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
img {
  max-width: 370px;
  width:80vw;
  margin-bottom: 30px;
}
.title {
  font-size: 2.375rem;
  text-transform: uppercase;
  color: var(--white);
  margin-top:45px;
}
h1, p {
    margin:5px 0;
}
h1 {
  color: var(--white);
  text-transform: uppercase;
  font-size: 1rem;      
  letter-spacing: 6.75px;  
}
.landing {
  flex-grow: 1;
  display: grid;
  align-items: end;
  position: relative;
  background-color:var(--black);
  background-image: url("~@/assets/images/welcome.jpg");  
  background-position: center;
  background-size: cover;
  display: grid;
    place-items: center;
  > div {
    padding: 25px 0;
    padding-bottom: 50px;    
    position: relative;    
  }  
}
</style>